import { Directive, input, output } from '@angular/core';
import { PlayerItemToPlay } from '../models';
import { ScrubBarSegment } from './scrub-bar-segment.interface';

@Directive()
export class SiScrubBarComponent {
  public schedulingItem = input<PlayerItemToPlay>();
  public scrubBarSegments = input.required<ScrubBarSegment []>();
  public mediaClicked = output<number>();

  protected mediaClickedEvent(index: number) {
    this.mediaClicked.emit(index);
  }

  protected segmentLabel(sbs: ScrubBarSegment): string {
    const si = this.schedulingItem();
    const segments = this.scrubBarSegments();
    const totalHours = segments.length;
    return `Hour ${sbs.index + 1} of ${totalHours}`;
  }

  /*
  protected scrubBarSegments = computed<ScrubBarSegment []>(() => {
    const segments: ScrubBarSegment [] = [];
    const medias = this.mediaItems();
    const playingIndex = this.mediaIndex();
    const siDuration = this.schedulingItemDuration();
    const siPosition = this.schedulingItemPosition();

    let segmentStart = 0;
    let index = 0;
    for(const media of medias) {
      const percOfTotal = (media.duration / siDuration) * 100.0;
      let played = false;
      let playing = false;
      let position = 0;
      let percPlayed = 0;
      if (index < playingIndex) {
        played = true;
        position = media.duration;
        percPlayed = 100;
      } else if (index === playingIndex) {
        playing = true;
        position = siPosition - segmentStart;
        percPlayed = position / media.duration * 100;
      }
      let name: string | undefined;
      if (media._segment) {
        name = this.segmentName(media._segment)
      }

      const segment: ScrubBarSegment = {
        index,
        played,
        playing,
        percOfTotal,
        duration: media.duration,
        position,
        name,
        percPlayed
      }
      index++;
      segmentStart += media.duration;
      segments.push(segment);
    }
    return segments;
  })

  protected segmentName(segment: PlayerSegment): string | undefined {
    if (segment.hourInShow) {
      return 'Hour ' + segment.hourInShow.toString();
    }
    return segment.name;
  }
   */
}
